import {
  GET_UNSUBSCRIBED_EMAILS,
  RESUBSCRIBE_EMAIL,
} from '../../state/actionTypes';

import { getIdMap } from '../../helpers/helpers';

const initialState = {};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_UNSUBSCRIBED_EMAILS: {
      const {
        payload: {
          emails = [],
        } = {},
      } = action;
      return getIdMap(emails, 'email');
    }
    case RESUBSCRIBE_EMAIL: {
      const {
        payload: {
          email,
        } = {},
      } = action;
      if (!email || !state[email]) return state;
      const next = { ...state };
      delete next[email];
      return next;
    }
    default:
      return state;
  }
};
